import React from 'react';
import GaugeChart from 'react-gauge-chart';

const QuizScoreCard = ({ quizScoreCardData , customButton }) => {
  return (
    <div className="flex flex-col  rounded-xl my-5 border-2 text-center p-5 md:w-1/2 mx-auto">
      <h3 className="text-2xl p-2 font-semibold">Quiz Scorecard</h3>
      <div className="mx-5">
        <GaugeChart
          id="gauge-chart"
          colors={['red', 'green']}
          textColor="#333"
          arcWidth={0.2}
          nrOfLevels={5}
          percent={quizScoreCardData.percentage}
        />
      </div>
      <h3 className="text-2xl p-2 font-semibold">
        {quizScoreCardData.correctAnswers}/
        {quizScoreCardData.correctAnswers +
          quizScoreCardData.incorrectAnswers +
          quizScoreCardData.unanswered}
      </h3>
      <h4 className="text-xl font-semibold p-1">
        Correct Answer: {quizScoreCardData.correctAnswers}
      </h4>
      <h4 className="text-xl p-1 font-semibold">
        Wrong Answer : {quizScoreCardData.incorrectAnswers}
      </h4>
      <h4 className="text-xl p-1 font-semibold">
        Skipped : {quizScoreCardData.unanswered}
        
      
      </h4>
      <div className='mx-5'>
        {customButton}
      </div>
    </div>
  );
};

export default QuizScoreCard;
